import { IConfig } from '@cian/config/shared';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatAvailableSelector } from '../../selectors/newbuildingConsultant';
import { NewbuildingChatContainer } from '../NewbuildingChat';

interface IChatContainerProps {
  config: IConfig;
}

export function ChatContainer({ config }: IChatContainerProps) {
  const isNewbuildingChat = useSelector(chatAvailableSelector);

  if (isNewbuildingChat) {
    return <NewbuildingChatContainer config={config} />;
  }

  return null;
}
